/**
 * Shared topic color system — single source of truth.
 *
 * 6 warm atelier colors, cycled by `color_index` on each topic.
 * Exported as hex values, tints, and CSS-variable-ready formats
 * so TopicBar, TopicWorkspace, and TopicCanvas stay in sync.
 */

export const COLOR_HEX: Record<string, string> = {
  coral:   '#D97F6F',
  blue:    '#6B9BD1',
  emerald: '#52A560',
  violet:  '#8B7AA8',
  amber:   '#E0B666',
  rose:    '#D97F8F',
};

/** Light tints for hover backgrounds (7% opacity) */
export const COLOR_TINTS: Record<string, string> = {
  coral:   'rgba(217,127,111,0.07)',
  blue:    'rgba(107,155,209,0.07)',
  emerald: 'rgba(82,165,96,0.07)',
  violet:  'rgba(139,122,168,0.07)',
  amber:   'rgba(224,182,102,0.07)',
  rose:    'rgba(217,127,143,0.07)',
};

/** Very light washes for stream/canvas backgrounds (3% opacity) */
export const COLOR_WASH: Record<string, string> = {
  coral:   'rgba(217,127,111,0.03)',
  blue:    'rgba(107,155,209,0.03)',
  emerald: 'rgba(82,165,96,0.03)',
  violet:  'rgba(139,122,168,0.03)',
  amber:   'rgba(224,182,102,0.03)',
  rose:    'rgba(217,127,143,0.03)',
};

import { getTopicColor } from '../../api/topics';

export function getColorHex(colorIndex: number): string {
  const color = getTopicColor(colorIndex);
  return COLOR_HEX[color.name] ?? COLOR_HEX.coral;
}

export function getColorTint(colorIndex: number): string {
  const color = getTopicColor(colorIndex);
  return COLOR_TINTS[color.name] ?? COLOR_TINTS.coral;
}

export function getColorWash(colorIndex: number): string {
  const color = getTopicColor(colorIndex);
  return COLOR_WASH[color.name] ?? COLOR_WASH.coral;
}
